@if (isDecisionModalVisible) {
  <div class="relative z-30" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-500/75 transition-opacity" aria-hidden="true"></div>
    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <div
          class="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
        >
          <div class="sm:flex sm:items-start">
            <div
              [ngClass]="{
                'bg-red-600': decisionLevel === level.Error,
                'bg-yellow-400': decisionLevel === level.Warning,
                'text-blue-500': decisionLevel === level.Info,
              }"
              class="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full sm:mx-0 sm:size-10"
            >
              <svg
                class="size-6 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
                data-slot="icon"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <div class="flex items-center">
                <h3 class="text-base font-semibold text-gray-900" id="modal-title">
                  {{ header }} <span class="font-bold"> {{ entityName }}</span>
                </h3>
                <button
                  (click)="decide(false)"
                  type="button"
                  class="text-gray-400 bg-transparent hover:bg-gray-200 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center absolute right-10"
                  appAgentAction
                  agent="decision-modal-close"
                  [businessObject]="businessObject"
                  [businessId]="entityId"
                  action="cancel"
                >
                  <svg
                    class="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span class="sr-only">Close modal</span>
                </button>
              </div>
              <div class="mt-2 max-h-40 overflow-y-auto">
                @for (line of details; track line) {
                  <p class="text-sm text-gray-500">
                    {{ line }}
                  </p>
                }
                @if (list && listTitle) {
                  <h3 class="text-base font-semibold text-gray-900 mt-1">{{ listTitle }}</h3>
                  <ul class="list-disc list-inside text-sm text-gray-500 mb-2">
                    @for (item of list; track $index) {
                      <li>{{ item }}</li>
                    }
                  </ul>
                }
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            @if (yesNoButtons) {
              <button
                (click)="decide(true)"
                type="button"
                class="inline-flex w-full justify-center rounded-md bg-amazone-orange px-3 py-2 text-sm font-semibold text-gray-50 ring-1 shadow-xs hover:scale-105 transition ease-in-out sm:mt-0 sm:w-auto"
                appAgentAction
                agent="decision-modal-confirm"
                [businessObject]="businessObject"
                [businessId]="entityId"
                action="confirm"
              >
                Yes!
              </button>
              <button
                (click)="decide(false)"
                type="button"
                class="inline-flex w-full justify-center rounded-md bg-amazone-gray me-2 px-3 py-2 text-sm font-semibold text-gray-50 ring-1 shadow-xs hover:scale-105 transition ease-in-out sm:mt-0 sm:w-auto"
                appAgentAction
                agent="decision-modal-cancel"
                [businessObject]="businessObject"
                [businessId]="entityId"
                action="cancel"
              >
                No, thanks
              </button>
            } @else {
              @for (button of buttons; track $index) {
                <button
                  (click)="decide(true, button.value)"
                  type="button"
                  class="mt-3 me-2 inline-flex w-full justify-center rounded-md bg-amazone-orange px-3 py-2 text-sm font-semibold text-gray-50 ring-1 shadow-xs hover:scale-105 transition ease-in-out sm:mt-0 sm:w-auto"
                  appAgentAction
                  [agent]="'decision-modal-option-' + button.value"
                  [businessObject]="businessObject"
                  [businessId]="entityId"
                  [action]="button.value"
                >
                  {{ button.text }}
                </button>
              }
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
